<template>
  <DocumentFormSection id="option-names" :required="true" :slot-max-width="1400" :show-description="false">
    <template v-if="optionNames.length">
      <OptionNameCommercialEdit
        v-for="option in optionNames"
        :key="option.option_id"
        :model-value="option.name || ''"
        class="w-full mt-4"
        :offer-title="option.code"
        :offer-name="option.name || ''"
        readonly
      />
    </template>
    <p v-else class="text-sm text-text-80">{{ $t("common.no-content") }}</p>
  </DocumentFormSection>
</template>

<script setup lang="ts">
import DocumentFormSection from "@/components/Document/FormSection/FormSection.vue";
import OptionNameCommercialEdit from "@/features/experience-curation/option-names/components/OptionNameCommercialEdit.vue";
import { RevisionFormProps } from "../types/forms";

const { $t } = useNuxtApp();

const props = defineProps<RevisionFormProps>();

const optionNames = computed(() => props.values?.optionNames ?? []);
</script>
